import { types } from 'mobx-state-tree';

export const CreatedByData = types.model({
  created_by_name: types.maybeNull(types.string),
  created_by_organization_name: types.maybeNull(types.string),
});
